export default "ui-chart-area{display:block}\n";